import { Injectable, InjectionToken, Inject } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Observable, from } from 'rxjs';
import { mergeMap, timeout } from 'rxjs/operators';
import { AdalService } from '../core/services/adal.service';
import { Constants } from '../helper/constants';
import { getCookie } from '../feature/login/utils/cookie-utils';
// import { MsalService } from '../msal/services/msal.service';
import { MsalService } from '@azure/msal-angular';



export const DEFAULT_TIMEOUT = new InjectionToken<number>('defaultTimeout');

@Injectable(
  {
    providedIn: 'root'
  }
)

export class ApiProxyInterceptor implements HttpInterceptor {
  constructor(
    private adal: AdalService,
    @Inject(DEFAULT_TIMEOUT) protected defaultTimeout: number,
    private msalService: MsalService) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<any> {

    let promise = null;
    const token = getCookie('token');
    if (token !== undefined) {
      promise = from(new Observable<string>((ob) => {
        ob.next(getCookie('token'));
      }));
    } else {
      if (req.url.includes(Constants.GRAPH_BASE_URL) || req.url.includes(Constants.GRAPH_BASE_URL_LIST)) {
        promise = this.adal.getGraphToken();
      } else if (this.msalService.instance.getAllAccounts().length !== 0) {
        promise = this.adal.getOneSiteToken();
      }
    }

    const timeoutValue = req.headers.get('timeout') || this.defaultTimeout;
    const observable = from(promise);

    return observable.pipe(
      mergeMap((adaltoken: string) => {
        const authorizedRequest = req.clone({
          headers: req.headers.set('Authorization', `Bearer ${adaltoken}`)
            .set('Cache-Control', 'no-cache, no-store, must-revalidate')
            .set('Pragma', 'no-cache')
            .set('Expires', '0')
            .set('X-Content-Type-Options', 'nosniff')
            .set('X-XSS-Protection', '1; mode=block')
            .set('Content-Security-Policy', 'default-src \'self\'')
        });
        return next.handle(authorizedRequest).pipe(timeout(Number(timeoutValue)));
      }));
  }

}
